import type { Experiments } from '@brighterly/lib-core-types/experiments/interface'
import type { ExperimentValue } from '@brighterly/lib-core-types/experiments/types'
import type { CustomerStore } from '@stores/me/customer/interfaces'

import { ExperimentsCode } from '@brighterly/lib-core-types/experiments/enum'

// TODO: remove ExperimentsCode.Exp68 from @brighterly/lib-core-types (closed 2026-04-21, branch: test)

const getExperiments = (state: CustomerStore): Experiments | null => state.customer?.experiments || null

const isExp90 = (state: CustomerStore): boolean => {
  const isExp = getExperiments(state)?.[ExperimentsCode.Exp90] === 'test' || false
  const isDemo = state.customer?.type === 'demo' || false
  return isExp && isDemo
}

const isGoalsActivation = (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp140] === 'test' || false

const isGoalsAnswerDescriptionHidden = (state: CustomerStore): boolean =>
  isGoalsActivation(state) && getExperiments(state)?.[ExperimentsCode.Exp155] === 'test'

const isPaceDiscountsEnabled = (state: CustomerStore): boolean =>
  getExperiments(state)?.[ExperimentsCode.Exp156] === 'test' && state.customer?.type === 'demo'

const isPracticeEnabled = (state: CustomerStore): boolean => {
  const isExp90 = getExperiments(state)?.[ExperimentsCode.Exp90] === 'test' || false
  const isExp108 = getExperiments(state)?.[ExperimentsCode.Exp108] === 'test' || false
  const isPaid = state.customer?.type === 'paid'
  return isPaid && (isExp90 || isExp108)
}

export const experiments = {
  getExperiments: (state: CustomerStore): Experiments | null => getExperiments(state),
  isExp79: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp79] === 'test',
  isExp92: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp92] === 'test',
  isExp113: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp113] === 'test',
  isExp141: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp141] === 'test',
  isExp90: (state: CustomerStore): boolean => isExp90(state),
  isPracticeEnabled: (state: CustomerStore): boolean => isPracticeEnabled(state),
  isLearningPlanEnabled: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp126] === 'test' || false,
  isRescheduleOnly: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp129] === 'test' || false,
  isPracticeBannerRepositioned: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp135] === 'test' || false,
  isNewFirstLessonOnboarding: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp134] === 'test' || false,
  isGoalsActivation: (state: CustomerStore): boolean => isGoalsActivation(state),
  isGoalsAnswerDescriptionHidden: (state: CustomerStore): boolean => isGoalsAnswerDescriptionHidden(state),
  isPracticeAfterLessonEnabled: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp136] === 'test' || false,
  isContactTutorEnabled: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp144] === 'test' || false,
  isChatFlowsEnabled: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp146] === 'test' || false,
  isHomepageUpdate: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp148] === 'test' || false,
  isUpsellSkipModalEnabled: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp152] === 'test' || false,
  isPaceDiscountsEnabled: (state: CustomerStore): boolean => isPaceDiscountsEnabled(state),
  isPracticeAfterCanceledLessonEnabled: (state: CustomerStore): boolean => getExperiments(state)?.[ExperimentsCode.Exp157] === 'test' || false,
  getFirstLessonOnboardingBranch: (state: CustomerStore): ExperimentValue | null => getExperiments(state)?.[ExperimentsCode.Exp134] || null,
}
